import ReactQuill, {Quill} from 'react-quill'
import QuillResizeImage from 'quill-resize-image'
import 'react-quill/dist/quill.snow.css'
import EditorToolbar, {
  modules,
  formats,
} from '../../../_metronic/layout/components/editor/EditorToolbar'

Quill.register('modules/resize', QuillResizeImage)

export function TestPage() {
  const Editor = {
    modules: {
      toolbar: {
        container: [['bold', 'italic', 'underline', 'strike', 'image', 'image']],
      },
      resize: {
        locale: {},
      },
    },
    formats: ['image'],
  }

  return (
    <div>
      TestPage
      <div>
        <EditorToolbar />
        <ReactQuill modules={modules} formats={formats} theme='snow' />
      </div>
    </div>
  )
}
